// extracted by extract-css-chunks-webpack-plugin
module.exports = {"navigationItem":"sDj1-","navigationItemText":"_9Q83-","navigationItemTextActive":"KH4NY"};